<template>
    <div>

        <div class="columns is-multiline">
            
            <div class="column is-half">
                <b-field label="Titulo">
                    <b-input
                        max="60"
                        required
                        v-model="details.title">
                    </b-input>
                </b-field>
            </div>
            <div class="column is-half">
                <b-field label="Actividad">
                    <b-input
                        max="60"
                        v-model="details.activity"
                    >
                    </b-input>
                </b-field>
            </div>
            <div class="column is-half">
                <b-field label="Minimo de orden para pagos por MP.">
                    <b-numberinput
                    v-model="details.mpMinOrder"
                    :controls="false">
                    </b-numberinput>
                </b-field>
            </div>
            <div class="column is-half">
                <b-field label="Minimo de orden para pagos por Paypal.">
                    <b-numberinput
                    v-model="details.ppMinOrder"
                    :controls="false">
                    </b-numberinput>
                </b-field>
            </div>
        </div>

        <div class="columns">
            <div class="column is-half">
                
                <b-field label="Email">
                    <b-input
                    input="email"
                    v-model="details.mainEmail"
                    >
                    </b-input>
                </b-field>
                
            </div>
            <div class="column is-half">
                <b-field label="Telefono">
                    <b-input
                    v-model="details.mainPhoneNumber">
                    </b-input>
                </b-field>
            </div>
        </div>

        <div class="columns">
            <div class="column is-full">
                <b-field label="Descripcion">
                    <b-input
                        type="textarea"
                        required
                        v-model="details.description"
                    >
                    </b-input>
                </b-field>
            </div>
        </div>

        <div class="columns is-multiline">
            <div class="column is-full">
                <h2 class="title is-size-4">Direccion</h2>
            </div>

            <div class="column is-half">
                <b-field label="Calle 1">
                    <b-input
                        max="60"
                        required
                        v-model="details.mainAddress"
                    >
                    </b-input>
                </b-field>
            </div>
            <div class="column is-half">
                <b-field label="Calle 2">
                    <b-input
                        max="60"
                        required
                        v-model="details.mainAddress2"
                    >
                    </b-input>
                </b-field>
            </div>
        </div>

        <div class="columns is-multiline">
            <div class="column is-half">
                <b-field label="Numero">
                    <b-input
                        v-model="details.mainNumber"
                    >
                    </b-input>
                </b-field>
            </div>

            <div class="column is-half">
                <b-field label="Zipcode">
                    <b-numberinput
                        min="0"
                        type="is-light"
                        controls-rounded
                        v-model="details.mainZipCode"
                    >
                    </b-numberinput>
                </b-field>
            </div>
        </div>

        <div class="columns">
            <div class="column is-half">
                <b-field autocomplete="off" label="Search a country">
                    <b-autocomplete
                        autocomplete="none"
                        v-model="details.countryName"
                        icon="search"
                        field="name"
                        :data="countries"
                        :loading="loadingCountries"
                        @input="fetchCountries"
                        @select="option => {
                            details.mainCountry = option.id
                            details.countryName = option.name
                        }"
                    >
                    <template slot-scope="props">
                    <p>{{props.option.name}}</p>
                    </template>
                    <template slot="empty">No country found...</template>
                    </b-autocomplete>
                </b-field>
            </div>
            <div class="column is-half">
                <b-field label="Ciudad y departamento (optional)">
                   <b-input
                        autocomplete="none"
                        max="60"
                        required
                        v-model="details.mainCity"
                    >
                    </b-input>
                </b-field>
            </div>
        </div>

        <div class="columns m-t-20">
            <div class="column is-full has-text-centered">
                <b-button
                type="is-primary"
                rounded
                @click="saveDetails">
                    <b-icon icon="save" size="is-small"></b-icon>
                    Guardar detalles
                </b-button>
            </div>
        </div>

    </div>
</template>

<script>
import {getHandler, patchHandler, debounce} from "./../../../../services/http.js"

export default {
    props:{
        details:{
            type:Object,
            default:new Object({})
        },
        detailsEndpoint:{
            type:String,
            default:''
        },
        countryList:{
            type:String,
            default:''
        },
        cityList:{
            type:String,
            default:''
        },
        loading:{
            type:Boolean,
            default:false,
        }
    },
    data(){
        return{
            saveLoading:false,
            loadingCountries:false,
            countries:[],
        }
    },
    methods:{
        async fetchDetails(){
            this.$emit("fetchDetails")
        },
        async saveDetails(){
            this.saveLoading = true
            let msg = {
                resource:'notify'
            }
            let resp = await patchHandler(this.detailsEndpoint, this.details, {error:msg, success:msg})
            this.fetchDetails()
            this.saveLoading = false
        },
        fetchCountries: debounce(
            async function(){
                this.loadingCountries = true
                let url = `${this.countryList}?country=${this.details.countryName}`
                let resp = await getHandler(url, {err:false, success:false})
                this.countries = resp
                this.loadingCountries = false
            },
            500
        ),
        
    },

}
</script>
